var consoleGroup, utils;

consoleGroup = require('when/monitor/logger/consoleGroup');

utils = require('base/lib/utils');

module.exports = function(rejections) {
  var rejection, _i, _len, _results;
  consoleGroup(rejections);
  if (typeof Raven === "undefined" || Raven === null) {
    return;
  }
  _results = [];
  for (_i = 0, _len = rejections.length; _i < _len; _i++) {
    rejection = rejections[_i];
    _results.push(utils.reportRavenError(rejection.reason));
  }
  return _results;
};
